import { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'antd';
import DOM from './settings';
import * as userActions from '../../core/user/userActions';

class SettingsPageForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDirty: false,
        };
        this.view = DOM;
    }

    compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('password')) {
            callback('Two passwords that you enter is inconsistent!');
        } else {
            callback();
        }
    }

    validateToNextPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], { force: true });
        }
        callback();
    }

    handleConfirmBlur = (e) => {
        const { value } = e.target;
        this.setState(s => ({ confirmDirty: s.confirmDirty || !!value }));
    }

    setNewPasswordSubmit = (e) => {
        e.preventDefault();
        const { form } = this.props;
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const { actions } = this.props;
                actions.changePasswordRequest({
                    password: values.password,
                });
            }
        });
    }

    render() {
        return this.view();
    }
}

SettingsPageForm.defaultProps = {
    actions: {},
};

SettingsPageForm.propTypes = {
    form: PropTypes.object.isRequired,
    actions: PropTypes.object,
};

const SettingsPage = Form.create()(SettingsPageForm);

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        isFetching: state.user.isFetching,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...userActions,
        }, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage);
